<div class="conflict-modal" [ngSwitch]="state">
    <ng-container *ngSwitchCase="'default'">
        <ng-container *ngTemplateOutlet="defaultTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'cancel'">
        <ng-container *ngTemplateOutlet="cancelTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'keep'">
        <ng-container *ngTemplateOutlet="keepTemplate"></ng-container>
    </ng-container>
    <ng-container *ngSwitchCase="'conflictNotCancelable'">
        <ng-container *ngTemplateOutlet="reservationTemplate"></ng-container>
    </ng-container>
</div>

<ng-template #defaultTemplate>
    <ng-container *ngTemplateOutlet="reservationTemplate"></ng-container>
    <div class="content">
        {{ data.labels.content }}
    </div>
    <div class="decision">
        {{ data.labels.decisionText }}
    </div>
    <div class="buttons">
        <finder-button theme="secondary" (click)="keepReservation()">
            {{ data.labels.button?.keep }}
        </finder-button>
        <finder-button theme="primary" (click)="cancelReservation()">
            {{ data.labels.button?.cancel }}
        </finder-button>
    </div>
</ng-template>

<ng-template #cancelTemplate>
    <ng-container *ngTemplateOutlet="reservationTemplate"></ng-container>
    <div class="content">
        {{ data.labels.cancelContent }}
    </div>
    <div class="buttons">
        <finder-button theme="secondary" (click)="back()">
            {{ data.labels.button?.back }}
        </finder-button>
        <finder-button theme="primary" (click)="confirmCancel()">
            {{ data.labels.button?.continue }}
        </finder-button>
    </div>
</ng-template>

<ng-template #keepTemplate>
    <div class="content">
        {{ data.labels.keepContent }}
    </div>
    <div class="buttons">
        <finder-button theme="primary" (click)="dismiss()">
            {{ data.labels.button?.close }}
        </finder-button>
    </div>
</ng-template>

<ng-template #reservationTemplate>
    <div class="reservation">
        <finder-font-icon name="dining" size="m"></finder-font-icon>
        <div class="detail">
            <h3 class="asset-name">{{ reservation.assetName }}</h3>
            <p class="location">{{ reservation.location }}</p>
            <p class="datetime">{{ reservation.dateTime }}</p>
            <p class="party-mix">
                {{ reservation.mealPeriod }}&nbsp;{{ reservation.forText }}&nbsp;{{ reservation.totalParty }}
            </p>
        </div>
    </div>
</ng-template>
